import { z } from 'zod'

const yearSearchParam = z.preprocess(
  (value) => (value === undefined || value === '' ? undefined : Number(value)),
  z.number().int().positive().optional()
)

export const studentSearchSchema = z.object({
  view: z.enum(['list', 'structure']).catch('list'),
  search: z.string().max(200).optional().catch(undefined),
  classId: z.string().optional().catch(undefined),
  groupId: z.string().optional().catch(undefined),
  year: yearSearchParam.catch(undefined),
  status: z
    .enum([
      'All',
      'InInternship',
      'WithFutureInternships',
      'WithPastInternships',
      'WithNoInternship',
    ])
    .catch('All'),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.string().min(1).catch('displayname'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type StudentSearch = z.infer<typeof studentSearchSchema>

export const defaultStudentSearch: StudentSearch = {
  view: 'list',
  classId: undefined,
  groupId: undefined,
  year: undefined,
  status: 'All',
  page: 1,
  pageSize: 10,
  sortBy: 'displayname',
  direction: 'asc',
}
